<template>
  <div>
    <viewTable
        ref="viewTable"
        :limits="limits"
        :columns-property="columnsProperty"
        :filter="filter"
        module="basic"
        url="transferBills"
        @addOrEdit="addEditHandle"
        @delete="deleteHandle"
        @reset="resetHandle"
        @select="selectHandle"
    >
      <template slot="otherBtn">
        <el-button v-if="limits.exportAuth" type="primary" :loading="exportLoading" @click="exportHandle">导出</el-button>
        <el-button v-if="limits.submitAuth" type="primary" :disabled="!selection.length" @click="submitHandle">
          提交
        </el-button>
        <el-button v-if="limits.cancelAuth" type="primary" :disabled="!selection.length" @click="repealHandle">
          撤销
        </el-button>
        <el-button v-if="limits.printAuth" type="primary" :disabled="!selection.length" @click="printHandle">
          打印调拨单
        </el-button>
      </template>
      <template slot="adSearch">
        <el-form :inline="true" :model="filter" @keyup.enter.native="loadData(1)">
          <el-form-item label="单据编号">
            <el-input v-model.trim="filter.billNo" placeholder="请输入单据编号" clearable/>
          </el-form-item>
          <el-form-item label="单据状态">
            <el-select v-model="filter.status" placeholder="请选择单据状态" clearable>
              <el-option label="未提交" :value="0"/>
              <el-option label="已提交" :value="1"/>
              <el-option label="已调拨" :value="2"/>
            </el-select>
          </el-form-item>
          <el-form-item label="单据类型">
            <el-select v-model="filter.transferType" placeholder="请选择单据类型" clearable>
              <el-option label="标准直接调拨单" :value="1"/>
              <el-option label="寄售直接调拨单" :value="2"/>
              <el-option label="委外直接调拨单" :value="3"/>
              <el-option label="分销直接调拨单" :value="4"/>
              <el-option label="VMI直接调拨单" :value="5"/>
            </el-select>
          </el-form-item>
          <el-form-item label="中心编号">
            <el-input v-model.trim="filter.relBillNo" placeholder="请输入生产中心编号" clearable/>
          </el-form-item>
          <el-form-item label="中心名称">
            <el-input v-model.trim="filter.relBillName" placeholder="请输入生产中心名称" clearable/>
          </el-form-item>
          <el-form-item label="要求时间">
            <el-date-picker
                v-model="requireDateRange"
                type="daterange"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                value-format="yyyy-MM-dd"
                @change="dateRangeChange('requireDateRange', 'requireTimeBegin', 'requireTimeEnd')"/>
          </el-form-item>
          <el-form-item label="创建时间">
            <el-date-picker
                v-model="createDateRange"
                type="daterange"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                value-format="yyyy-MM-dd"
                @change="dateRangeChange('createDateRange', 'createTimeStart', 'createTimeEnd')"/>
          </el-form-item>
          <el-form-item label="创建人">
            <el-input v-model.trim="filter.creatorName" placeholder="请输入创建人" clearable/>
          </el-form-item>
          <el-form-item label="过账人">
            <el-input v-model.trim="filter.completeName" placeholder="请输入过账人" clearable/>
          </el-form-item>
          <el-form-item label="物料号">
            <el-input v-model.trim="filter.materialNo" placeholder="请输入物料号" clearable/>
          </el-form-item>
          <el-form-item label="调出仓位">
            <el-select v-model="filter.outLocationNo" placeholder="请选择调出仓位" clearable>
              <el-option
                v-for="item in constants.locationNo.$options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
            />
            </el-select>
          </el-form-item>
        </el-form>
      </template>
      <template slot="actionBtn" slot-scope="scope">
        <!--        <el-button v-if="limits.sureAuth" :disabled="scope.row.status !== 1" type="primary" @click="allotHandle(scope.row.pkId)">-->
        <!--          调拨-->
        <!--        </el-button>-->
        <el-button v-if="limits.sureAuth" :disabled="scope.row.status === 2" type="primary" @click="post(scope.row)">过账</el-button>
      </template>
    </viewTable>
    <allot-order-edit ref="allotOrderEdit" :is-view="isView" @save-success="loadData"/>
  </div>
</template>

<script>
  import viewTable from "@/components/ViewTable.vue";
  import AllotOrderEdit from "./AllotOrderEdit.vue";
  import constants from "@/util/constants";

  export default {
    name: "AllotOrder",
    components: {viewTable, AllotOrderEdit},
    data() {
      return {
        constants,
        isView: false,
        selection: [],
        ids: [],
        requireDateRange: [],
        createDateRange: [],
        limits: {
          addAuth: this.$auth(542),
          editAuth: this.$auth(543),
          delAuth: this.$auth(544),
          submitAuth: this.$auth(547),
          cancelAuth: this.$auth(548),
          printAuth: this.$auth(549),
          sureAuth: this.$auth(546),
          exportAuth:this.$auth(520),
        },
        filter: {
          billNo: "",
          status: "",
          relBillNo: "",
          completeName: "",
          relBillName: "",
          transferType: "",
          requireTimeBegin: "",
          requireTimeEnd: "",
          createTimeStart: "",
          createTimeEnd: "",
        },
        exportLoading: false,
        columnsProperty: [
          {
            tooltip: true,
            key: "billNo",
            width: 120,
            align: "center",
            render: (h, params) => {
              return h(
                "span",
                {
                  style: {
                    color: "#2d8cf0",
                    cursor: "pointer",
                  },
                  on: {
                    click: () => {
                      this.isView = true;
                      this.$refs.allotOrderEdit.open(params.row, true);
                    },
                  },
                },
                params.row.billNo,
              );
            },
          },
          {
            tooltip: true,
            key: "transferTypeName",
            width: 160,
            align: "center",
          },
          {
            tooltip: true,
            key: "statusName",
            width: 120,
            align: "center",
          },
          {
            tooltip: true,
            key: "relBillNo",
            width: 140,
            align: "center",
          },
          {
            key: "relBillName",
            width: 180,
            tooltip: true,
            align: "center",
          },
          {
            tooltip: true,
            key: "requireDate",
            width: 180,
            align: "center",
          },
          {
            key: "note",
            tooltip: true,
          },
          {
            key: "action",
            align: "center",
            width: 190,
            slot: "action",
            fixed: "right",
          },
        ],
      };
    },
    methods: {
      addEditHandle(row) {
        this.isView = false;
        this.$refs.allotOrderEdit.open(row);
      },
      post(row) {
        this.isView = false;
        this.$refs.allotOrderEdit.open(row, true);
      },
      loadData(pageNum) {
        this.selection = [];
        this.$refs.viewTable.loadData(pageNum);
      },

      // 删除
      deleteHandle(row) {
        this.$http.delete("basic", "transferBills", row.pkId).then((resp) => {
          if (resp.success) {
            this.loadData();
            this.$message.success("删除成功");
          }
        });
      },

      dateRangeChange(timeRange, timeStart, timeEnd) {
        if (this[timeRange]) {
          this.filter[timeStart] = this[timeRange][0];
          this.filter[timeEnd] = this[timeRange][1];
        } else {
          this.filter[timeStart] = "";
          this.filter[timeEnd] = "";
        }
      },


      selectHandle(selection) {
        this.selection = selection;
        this.ids = [];
        this.selection.forEach((item) => {
          this.ids.push(item.pkId);
        });
      },

      // 提交
      submitHandle() {
        const arr = this.selection.filter((item) => item.status);
        if (arr.length) {
          this.$confirm("请选择未提交的单据", "错误", {
            type: "error",
            showCancelButton: false,
          });
        } else {
          this.$confirm("确定提交吗?", "提示", {type: "warning"}).then(() => {
            this.$http.post("basic", "transferBills/submit", this.ids).then((res) => {
              if (res.success) {
                this.loadData();
                this.$message.success("提交成功");
              }
            });
          });
        }
      },

      // 撤销
      repealHandle() {
        const arr = this.selection.filter((item) => item.status === 2);
        if (arr.length) {
          this.$confirm("请选择已提交的单据", "错误", {
            type: "error",
            showCancelButton: false,
          });
        } else {
          this.$confirm("确定撤销吗?", "提示", {type: "warning"}).then(() => {
            this.$http.post("basic", "transferBills/cancel", this.ids).then((res) => {
              if (res.success) {
                this.loadData();
                this.$message.success("撤销成功");
              }
            });
          });
        }
      },

      // 打印
      printHandle() {
        const routeUrl = this.$router.resolve({
          path: "/allotOrderPrint",
          query: {
            params: JSON.stringify(this.ids),
          },
        });
        window.open(routeUrl.href, "_blank");
      },

      // 调拨
      allotHandle(pkId) {
        this.$confirm("确认调拨吗?", "提示", {type: "warning"}).then(() => {
          this.$http.post("basic", `transferBills/transfer?id=${pkId}`).then((res) => {
            if (res.success) {
              this.loadData();
              this.$message.success("操作成功");
            }
          });
        });
      },

      // 单据状态为未提交的才能编辑/删除
      otherAuth(row) {
        return row.status !== 0 ? true : false;
      },

      // 重置
      resetHandle(filter) {
        this.filter = Object.assign(this.filter, filter);
      },

      // 导出处理
      exportHandle() {
        this.exportLoading = true;
        let params = Object.assign({}, this.filter);
        this.$http.exportExcel("basic", "transferBills/export", params)
          .then((res) => {
            // const blob = new Blob([res.data]);
            // const downloadElement = document.createElement("a");
            // const href = window.URL.createObjectURL(blob);
            // const contentDisposition = res.headers["content-disposition"];
            // let fileName = "导出数据";
            // if (contentDisposition) {
            //   fileName = decodeURI(contentDisposition.split("filename*=utf-8''")[1].split(".")[0]);
            // }
            // downloadElement.style.display = "none";
            // downloadElement.href = href;
            // downloadElement.download = fileName + ".xls"; // 下载后文件名
            // document.body.appendChild(downloadElement);
            // downloadElement.click(); // 点击下载
            // document.body.removeChild(downloadElement); // 下载完成移除元素
            // window.URL.revokeObjectURL(href); // 释放掉blob对象
            // 创建Blob对象
            const blob = new Blob([res.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });

            // 创建下载链接
            const link = document.createElement("a");
            const url = window.URL.createObjectURL(blob);

            // 设置下载文件名
            const fileName = `调拨单明细数据_${new Date().toLocaleDateString().replace(/\//g, "-")}.xlsx`;
            link.href = url;
            link.download = fileName;

            // 触发下载
            document.body.appendChild(link);
            link.click();

            // 清理
            setTimeout(() => {
              document.body.removeChild(link);
              window.URL.revokeObjectURL(url);
            }, 100);

            this.$message.success("导出成功");
          })
          .catch(() => {
            this.exportLoading = false;
            this.$message.error("导出失败");
          })
          .finally(() => {
            this.exportLoading = false;
          });
      },
    },
  };
</script>
